import React, { useEffect, useState } from "react";
import { useQuery, gql } from "@apollo/client";
import {
  Switch,
  Route,
  Link,
  useParams,
  useRouteMatch,
  useHistory,
} from "react-router-dom";

import { XIcon } from "@heroicons/react/solid";

export const ImageUpload = (props) => {
  const history = useHistory();

  const [image, setImage] = useState("");
  const [url, setUrl] = useState("");
  const uploadImage = () => {
    const data = new FormData();
    data.append("file", image);
    data.append("upload_preset", "a7xscswa");
    data.append("cloud_name", "computer-computer");
    data.append("public_id", "testingggg");
    data.append("overwrite", "true");

    fetch("  https://api.cloudinary.com/v1_1/computer-computer/image/upload", {
      method: "post",
      body: data,
    })
      .then((resp) => resp.json())
      .then((data) => {
        setUrl(data.url);
        console.log(data);
      })
      .catch((err) => console.log(err));
  };
  return (
    <div className="pt-32 h-screen overflow-y-auto">
      <div className="glass rounded-t-md pt-2 relative">
        <XIcon
          className="absolute w-8 h-8 top-2 right-2 z-10"
          onClick={() => history.goBack()}
        />
        <input
          type="file"
          onChange={(e) => setImage(e.target.files[0])}
        ></input>
        <button onClick={uploadImage}>Upload</button>

        <h1>Uploaded image will be displayed here</h1>
        <img src={url} />
      </div>
    </div>
  );
};
